import { useMutation, useQueryClient } from '@tanstack/react-query';
import { feedbackApi } from '../api/feedback';
import type { FeedbackCreateRequest } from '../types/feedback';

/**
 * POST /api/eraf/catalog/feedback — 인증-any(guest 포함) 제출 뮤테이션.
 * queryKey: ['common-showcase', 'feedback', 'list'] · ['common-showcase', 'feedback', 'mine']
 * (queue #684: 제출 직후 '내 문의 이력' 탭에도 즉시 반영되도록 mine 도 invalidate)
 */
export function useSubmitFeedback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: FeedbackCreateRequest) => feedbackApi.submit(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'feedback', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'feedback', 'mine'] });
    },
  });
}
